export const URL_DOMAIN = 'https://www.naranjax.com';
export const FRONT_URL = 'https://www.naranjax.com/ayuda';
export const BACKEND_URL = 'https://bff-faqs-naranjadotcom.backendnaranja.com';
export const BFF_URL = 'https://bik.backendnaranja.com/app-contactscreen/api';
export const API_SERVICE_URL = 'https://services.apinaranja.com';
export const CHAT_BOT_FE_URL = 'https://bik-chat-bot-website.naranjax.com/';
export const CHAT_BOT_CHANNEL_NAME = 'YZQMURTBFV';

export const environment = {
  chatBotURL: CHAT_BOT_FE_URL,
  chatBotChannelName: CHAT_BOT_CHANNEL_NAME,
  urlDomain: URL_DOMAIN,
  production: true,
  language: {
    default: 'es',
  },
  downloadAppLink: 'http://s.naranja.com/38xC44a?r=qr',
  homeRedirect: 'nx://home',
  homePath: '/',
  whatsappServiceBffUrl:
    'https://www.backendnaranja.com/bff-general/botmaker/template',
  seo: {
    gtmId: 'GTM-NTJ9H3J',
    surveyId: 'figma_faqs',
    logging: true,
    canonicalDomain: `${FRONT_URL}`,
    noIndex: false,
  },
  urls: {
    faqs: {
      getCategories: `${BACKEND_URL}/faqs/main/`,
      getSubCategoriesByCategory: `${BACKEND_URL}/faqs/subcategoriesByCategory/`,
      getSubCategoriesBySubcategory: `${BACKEND_URL}/faqs/subcategoriesBySubcategory/`,
      getSubCategories: `${BACKEND_URL}/faqs/subcategories/`,
      getQuestionList: `${BACKEND_URL}/faqs/questionList/`,
      getQuestionListById: `${BACKEND_URL}/faqs/questionListById/`,
      getTopQuestionList: `${BACKEND_URL}/faqs/topQuestionList/`,
      getSubCategoriesByName: `${BACKEND_URL}/faqs/subcategoriesByName/`,
      getQuestionListByName: `${BACKEND_URL}/faqs/questionListByName/`,
      getQuestionByName: `${BACKEND_URL}/faqs/questionByName/`,
      getBreadcrumb: `${BACKEND_URL}/faqs/Breadcrumb/`,
      getBreadcrumbById: `${BACKEND_URL}/faqs/questionBreadcrumb/`,
      autocomplete: `${BACKEND_URL}/faqs/autocomplete`,
      searchFaqs: `${BACKEND_URL}/faqs/search`,
      faqsHero: `${BACKEND_URL}/faqs/faqSearch`,
      pillsHelp: `${BACKEND_URL}/faqs/pillsHelp`,
      footer: `${BACKEND_URL}/faqs/footer/`,
      navbar: `${BACKEND_URL}/faqs/nav/`,
      customers: `${BACKEND_URL}/customers`,
    },
    bff: {
      options: `${BFF_URL}/content/options`,
      status: `${BFF_URL}/status`,
    },
  },
};
